import React, { useState, createContext } from 'react';
type Config = {
  isKfasEnabled?: boolean;
  kfasClientId?: number;
};

type ConfigContextType = {
  config: Config | null;
  setConfig: React.Dispatch<React.SetStateAction<Config | null>>;
};

type ConfigContextProviderProps = {
  children: React.ReactNode;
};
export const ConfigContext = createContext({} as ConfigContextType);

export const ConfigContextProvider = ({
  children,
}: ConfigContextProviderProps) => {
  const [config, setConfig] = useState<Config | null>(null);
  return (
    <ConfigContext.Provider value={{ config, setConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};
